// extracted by mini-css-extract-plugin
export default {"top":"ProfessInfo_top__oJcIs","headline":"ProfessInfo_headline__MbK5Y","input":"ProfessInfo_input__0B63F","sec":"ProfessInfo_sec__sEJdR"};